<script lang="ts" context="module">
  export const matchingProps = [];
</script>

<script lang="ts">
  import _ from 'lodash';
  import AdminGridWithDetail from '../admin/AdminGridWithDetail.svelte';
  import AdminConnectionsGridCore from '../admin/AdminConnectionsGridCore.svelte';
  import ConnectionTab from './ConnectionTab.svelte';
  import { getConnectionLabel } from 'dbgate-tools';
  import { apiCall } from '../utility/api';
  import { writable } from 'svelte/store';

  const filters = writable({});

  export let tabid;
  let domConnections;
</script>

<AdminGridWithDetail
  {tabid}
  requiredPermission="admin/connections"
  adminLabel="Connections"
  apiCallList="storage/get-connection-list"
  apiCallGetDetail="storage/get-connection-detail"
  apiCallSaveDetail="storage/save-connection-detail"
  newObjectLabel="New connection"
  pureTableName="connections"
  labelField={conn => getConnectionLabel(conn)}
  normalizeFormValues={values => {
    let res = {
      ...values,
      useDatabaseUrl: values.useDatabaseUrl ? 1 : 0,
      isReadOnly: values.isReadOnly ? 1 : 0,
      trustServerCertificate: values.trustServerCertificate ? 1 : 0,
      singleDatabase: values.singleDatabase ? 1 : 0,
      useSshTunnel: values.useSshTunnel ? 1 : 0,
      useSsl: values.useSsl ? 1 : 0,
      sslRejectUnauthorized: values.sslRejectUnauthorized ? 1 : 0,
    };
    if (domConnections) {
      res = domConnections.changeConnectionBeforeSave(res);
    }
    return res;
  }}
>
  <svelte:fragment slot="table" let:rows let:onSetSelectedObject let:onRefresh>
    <AdminConnectionsGridCore
      allConnections={rows}
      {filters}
      on:clickrow={e => {
        onSetSelectedObject(e.detail.id);
      }}
      onDelete={async id => {
        await apiCall('storage/delete-connection', { id });
        onRefresh();
      }}
      onCopy={
        async (id, name) => {
          await apiCall('storage/copy-connection', { id, name });
          onRefresh();
        }
      }
    />
  </svelte:fragment>

  <svelte:fragment slot="detail" let:values let:selectedObjectStore>
    <ConnectionTab bind:this={domConnections} connectionStore={selectedObjectStore} onlyTestButton inlineTabs />
  </svelte:fragment>
</AdminGridWithDetail>

<style>
  .details-tab {
    display: flex;
    flex: 1;
  }

  h4 {
    text-transform: uppercase;
    font-weight: normal;
    color: var(--theme-font-2);
  }
</style>
